<div class="text-3xl font-bold">
  <ng-content></ng-content>
  <span><ng-content select="[secondary]"></ng-content></span>
</div>
